import React from "react";
import { ImageSlide } from "./Buddies";
// import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

const Meet = () => {
  return (
    <section>
      <ImageSlide
        heading="Meet Your Next..."
        body="Fufil will connect you with with members for you to help, and others to help you. It uses your areas and location."
        clicked={() => {}}
      />
    </section>
  );
};

export default Meet;
